// JSON-LD Schema configurations for structured data

export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.wanderobe.co/#localbusiness",
  "name": "Wanderobe",
  "url": "https://www.wanderobe.co/",
  "description": "Wanderobe is where travel meets style. Our luxury fashion concierge service delivers curated wardrobes from independent designers and fashion brands in New York City, directly to your hotel room. Whether you're packing light, traveling for an occasion, or want to elevate your wardrobe with high-end pieces from local fashion brands, we make shopping while traveling effortless. Each piece reflects the identity, artistry, and energy of the place you're visiting—offering a wearable connection to the culture around you. Made for the modern, conscious traveler who shops sustainably and values style as a cultural experience.",
  "slogan": "Where travel meets style.",
  "image": "https://www.wanderobe.co/favicon-512.png",
  "areaServed": {
    "@type": "City",
    "name": "New York City",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "New York",
      "addressRegion": "NY",
      "addressCountry": "US"
    }
  },
  "serviceType": [
    "Luxury fashion concierge",
    "Curated wardrobe delivery to hotels",
    "Independent & local designer fashion curation"
  ],
  "location": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "New York",
      "addressRegion": "NY",
      "addressCountry": "US"
    }
  },
  "inLanguage": "en"
};

export const ABOUT_PAGE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "@id": "https://www.wanderobe.co/about#webpage",
  "url": "https://www.wanderobe.co/about",
  "name": "About Wanderobe",
  "description": "Learn about Wanderobe—where travel meets style. We deliver curated wardrobes from independent New York City designers directly to your hotel, blending culture, sustainability, and elevated fashion for modern travelers.",
  "inLanguage": "en",
  "isPartOf": {
    "@type": "WebSite",
    "@id": "https://www.wanderobe.co/#website",
    "url": "https://www.wanderobe.co/",
    "name": "Wanderobe"
  },
  "about": {
    "@type": "Organization",
    "@id": "https://www.wanderobe.co/#organization",
    "name": "Wanderobe",
    "url": "https://www.wanderobe.co/",
    "description": "Luxury fashion concierge delivering curated wardrobes from independent New York City designers directly to your hotel room for a cultural, sustainable shopping experience while traveling."
  },
  "mainEntity": {
    "@type": "Organization",
    "@id": "https://www.wanderobe.co/#organization"
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.wanderobe.co/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://www.wanderobe.co/about"
      }
    ]
  }
};

